import React from 'react';
import { DisappearedLoading } from 'react-loadingg';

const CpBaseLoading = () => {
  return <DisappearedLoading color={'var(--productSatsuma)'} size="Large" />;
};

export default CpBaseLoading;
